export const border = {
  borderRadius: {
    sm: "2px", 
    md: "4px",
    lg: "8px", 
    xl: "10px",
    half: "50%",
  },
};
